import React from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip as RechartsTooltip,
  XAxis,
  YAxis,
} from "recharts";
import { Panel } from "../ui";
import { hasAnySeriesData } from "./dashboardUtils";

const ModuleVolumeCard = ({ title, subtitle, series, color, emptyLabel, totalLabel }) => {
  const hasData = hasAnySeriesData(series);

  return (
    <Panel title={title}>
      <Box p="12px">
        <Text
          fontSize="19px"
          fontWeight="900"
          letterSpacing="-0.04em"
          color="portal.text"
          sx={{ marginBottom: "2px !important" }}
        >
          {totalLabel}
        </Text>
        <Text fontSize="12px" color="portal.muted" sx={{ marginBottom: "12px !important" }}>
          {subtitle}
        </Text>

        {hasData ? (
          <ResponsiveContainer width="100%" height={220}>
            <BarChart data={series} margin={{ top: 8, right: 12, left: -12, bottom: 0 }}>
              <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#EDF2F5" />
              <XAxis dataKey="label" tick={{ fontSize: 11, fill: "#617386" }} stroke="#D6E0EA" />
              <YAxis tick={{ fontSize: 11, fill: "#617386" }} stroke="#D6E0EA" allowDecimals={false} />
              <RechartsTooltip formatter={(value) => value} />
              <Bar dataKey="value" fill={color} radius={[8, 8, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        ) : (
          <Flex
            h="220px"
            borderRadius="10px"
            bg="portal.soft"
            borderWidth="1px"
            borderColor="portal.line"
            align="center"
            justify="center"
            px="24px"
          >
            <Text fontSize="12px" color="portal.muted" textAlign="center" sx={{ marginBottom: "0 !important" }}>
              {emptyLabel}
            </Text>
          </Flex>
        )}
      </Box>
    </Panel>
  );
};

export default ModuleVolumeCard;
